export default "__VITE_ASSET__60435410__"